<template>
  <div class="thumbnail-container" :class="column ? 'flex-column' : ''">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AnswerContainer",
  props: ["column"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.thumbnail-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.flex-column {
  flex-direction: column;
}

.thumbnail-container input {
  margin: 0;
  padding: 0;
  display: none;
}
</style>
